import styled from 'styled-components';
import { device } from '@/styles/helpers';

export const ScHeadlinePromoPage = styled.div`
  position: relative;
  background: ${({ theme }) => theme.blackColor};
  margin-top: -96px;

  @media (${device.mobile}) {
    margin-top: -88px;
  }
`;
